import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppToolbar } from "../components/AppToolbar";
import { Grid } from "@material-ui/core";
import { Box } from "@mui/material";
import MissingInformationTile from "../components/Dashboard/MissingInformationTile";
import UserService from "../services/UserService";
import Dashboard from "../models/Dashboard";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import PendingTimeoffTile from "../components/Dashboard/PendingTimeoffTile";
import RequestedTimeOff from "../components/Dashboard/RequestedTimeOff";
import UpcomingTimeoffsTile from "../components/Dashboard/UpcomingTimeoffsTile";
import MissingWorklogsTile from "../components/Dashboard/MissingWorklogsTile";
import EmptyDashboard from "../components/Dashboard/EmptyDashboard";
import { SpinnerWrapper } from "../components/SpinnerWrapper";
import PendingWeeklyApprovalsTile from "../components/Dashboard/PendingWeeklyApprovalsTile";
import SitesTile from "../components/Dashboard/SitesTile";
import { useSiteList } from "../hooks/useSiteList";

export default function DashboardList() {
  const { t } = useTranslation();

  const [dashboard, setDashboard] = useState<Dashboard>();
  const { siteActions } = useSiteList();

  useEffect(() => {
    loadContent();
    siteActions.getRecommendedSites(0, 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadContent = async () => {
    (await UserService.getDashboard()).onSuccess((response) => setDashboard(response)).onError((err) => NotificationService.error(err));
  };

  const areActivitiesToShow = (instance: Dashboard) => {
    return (
      instance.missingWorklogsPerProject.length > 0 ||
      instance.timeoffPendingApproval.length > 0 ||
      instance.upcomingTimeoffs.length > 0 ||
      instance.missingInformation.length > 0 ||
      instance.myTimeoffs.length > 0
    );
  };

  const areSitesToShow = () => {
    return siteActions.result !== undefined && siteActions.result > 0;
  };

  const emptyDashboard = () => {
    return dashboard && !areActivitiesToShow(dashboard) && !areSitesToShow();
  };

  const panels = [
    dashboard && dashboard!.missingWorklogsPerProject.length > 0 && <MissingWorklogsTile rows={dashboard!.missingWorklogsPerProject} />,
    dashboard?.myTimeoffs && <RequestedTimeOff rows={dashboard?.myTimeoffs} />,
    dashboard?.missingInformation && <MissingInformationTile rows={dashboard?.missingInformation} />,
    dashboard?.timeoffPendingApproval && <PendingTimeoffTile rows={dashboard?.timeoffPendingApproval!} fetchData={loadContent} />,
    dashboard?.pendingApprovalWeeks && <PendingWeeklyApprovalsTile rows={dashboard!.pendingApprovalWeeks} />,
    dashboard?.upcomingTimeoffs && <UpcomingTimeoffsTile rows={dashboard!.upcomingTimeoffs} />
  ]

  return (
    <SpinnerWrapper isLoading={dashboard === undefined}>
      {dashboard && areActivitiesToShow(dashboard) && (
        <>
          <AppToolbar title={t("Dashboard")} />
          <Box paddingTop={3} display={"flex"} flexDirection={"row"} paddingBottom={1}>
            <Grid container spacing={3} justify="space-between">
              {panels.map((panel, index) => (
                <Grid key={index} item xs={4}>
                  {panel}
                </Grid>
              ))}
            </Grid>
          </Box>
        </>
      )}
      {areSitesToShow() && (
        <>
          <Box paddingTop={1} display={"flex"} flexDirection={"row"}>
            <SitesTile />
          </Box>
        </>
      )}
      {emptyDashboard() && <EmptyDashboard />}
    </SpinnerWrapper>
  );
}
